import { useMemo } from 'react';

const SPRITES = ['leaf-russet', 'leaf-gold', 'leaf-ochre'] as const;
const PATH_COUNT = 4;
const LEAF_COUNT = 22;

export function LeafStorm() {
  const leaves = useMemo(
    () =>
      Array.from({ length: LEAF_COUNT }, (_, i) => ({
        sprite: SPRITES[i % SPRITES.length],
        path: (i % PATH_COUNT) + 1,
        delay: Math.round(Math.random() * 800),
        left: Math.round(Math.random() * 100),
      })),
    [],
  );

  return (
    <div className="leaf-storm" aria-hidden>
      {leaves.map((leaf, i) => (
        <img
          key={i}
          className={`leaf-storm__leaf leaf-storm-${leaf.path}`}
          src={`/leaves/${leaf.sprite}.png`}
          alt=""
          style={{ left: `${leaf.left}%`, animationDelay: `${leaf.delay}ms` }}
        />
      ))}
    </div>
  );
}
